export default __webpack_public_path__ + "static/media/AlterImg.ee91cc9f.jpeg";